import React, { useEffect, useState } from 'react';
import { Chart } from 'primereact/chart';

export default function GraficoDeLinhas(props) {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    // Simulando o JSON recebido
    console.log(props.data)
    
    const dados = props.data || [];
    if(dados && dados.length > 0){
        setChartData({
        labels: dados.map(item => item.dia),
        datasets: [
            {
            label: 'Ligados',
            data: dados.map(item => item.total),
            fill: false,
            borderColor: '#4f46e5', // azul escuro
            backgroundColor: '#4f46e5',
            tension: 0.3,
            pointRadius: 4,
            },
        ]
        });

        setChartOptions({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
            labels: {
                color: '#374151',
                usePointStyle: true,
            },
            },
        },
        scales: {
            x: {
            ticks: {
                color: '#374151'
            },
            grid: {
                color: '#e5e7eb'
            }
            },
            y: {
            beginAtZero: true,
            ticks: {
                color: '#374151'
            },
            grid: {
                color: '#e5e7eb'
            }
            }
        }
        });
    }
    
  }, [props.data]);


  return (
    <div className="card" style={{ height: '200px' }}>
      <h5 className="text-center mb-2">Equipamentos Ligados (diariamente)</h5>
      <Chart type="line" data={chartData} options={chartOptions} className="w-full h-full" />
    </div>
  );
}
